export default "__VITE_ASSET__dy7weGQj__"